export const getEnv = (origin: string) => {
  if (origin.includes('chrome-extension://fdengbikckdhbbliklkdnbglacleeogg')) return 'production'; // production chrome extension, dev right now for testing
  if (origin.includes('//localhost')) return 'local';
  if (origin.includes('.ngrok-free.app')) return 'local';
  if (origin.includes('//127.0.0')) return 'local';
  if (origin.includes('//dev.') || origin.includes('.dev.')) return 'dev';
  if (origin.includes('//test.') || origin.includes('.test.')) return 'test';
  return 'production';
};
